module.exports = __webpack_public_path__ + "img/image_11.5aa84e77.png";